/* eslint-disable string-to-lingui/missing-lingui-transformation */
import Box from '@mui/material/Box/Box'
import { DateAwareFilterDTO_Output } from '@om1/falcon-api/codegen/client/models/DateAwareFilterDTO_Output'
import { FilterDTO_Output } from '@om1/falcon-api/codegen/client/models/FilterDTO_Output'
import { PaginatedDTO_RefResultDTO_ } from '@om1/falcon-api/codegen/client/models/PaginatedDTO_RefResultDTO_'
import { PaginateMeta } from '@om1/falcon-api/codegen/client/models/PaginateMeta'
import { RefTable } from '@om1/falcon-api/codegen/client/models/RefTable'
import { ExplorerAnalyticsRefService } from '@om1/falcon-api/codegen/client/services/ExplorerAnalyticsRefService'
import { FC, useCallback, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { fetchData } from '../queryUtils'

export const ObservationDialogContents: FC<{ editBlock: FilterDTO_Output | DateAwareFilterDTO_Output }> = ({ editBlock }) => {
    const [refs, setRefs] = useState<Array<Record<string, any>>>([])
    const fetchRefs = useCallback(async (filter: FilterDTO_Output | DateAwareFilterDTO_Output) => {
        const paginatedDict: PaginatedDTO_RefResultDTO_ = await fetchData(
            'explorerCohorts',
            { refTableName: `ref_observation` as RefTable, page: 1, limit: 100, query: null, filters: filter.values },
            ExplorerAnalyticsRefService.indexExplorerAnalyticsRefRefTableNameGet
        )
        setRefs(paginatedDict.data)
    }, [])
    const [refData, setRefData] = useState<Array<Record<string, any>>>([])
    const [refResults, setRefResults] = useState<Array<Record<string, any>>>([])
    useEffect(() => {
        fetchRefs(editBlock)
    }, [editBlock, fetchRefs])

    useEffect(() => {
        setRefData(refs)
    }, [refs])

    const [query, setQuery] = useState('')
    const [refMeta, setRefMeta] = useState<PaginateMeta>({
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: 10
    })
    const [pendingBlockValues, setPendingBlockValues] = useState<Array<string>>(editBlock.values)
    const initialBlockValues = editBlock.values
    const isInitialBlockValues = JSON.stringify(pendingBlockValues) === JSON.stringify(initialBlockValues)

    useEffect(() => {
        const fetchDataAsync = async () => {
            const data = await fetchData(
                'explorerCohorts',
                {
                    refTableName: `ref_observation` as RefTable,
                    page: 1,
                    limit: 100,
                    query: query,
                    filters: []
                },
                ExplorerAnalyticsRefService.indexExplorerAnalyticsRefRefTableNameGet
            )
            setRefData((prevData) => [...prevData, ...data.data])
            setRefResults(data.data)
            setRefMeta(data.meta)
        }

        fetchDataAsync()
    }, [query, editBlock.table])

    const fetchMoreData = useCallback(async () => {
        const data = await fetchData(
            'explorerCohorts',
            {
                refTableName: `ref_observation` as RefTable,
                page: refMeta?.currentPage + 1,
                limit: 100,
                query: query,
                filters: []
            },
            ExplorerAnalyticsRefService.indexExplorerAnalyticsRefRefTableNameGet
        )

        setRefData((prevData) => [...prevData, ...data.data])
        setRefResults(data.data)
        setRefMeta(data.meta)
    }, [refMeta?.currentPage, query])

    const hasMoreData = refMeta?.currentPage && refMeta?.totalPages ? refMeta?.currentPage < refMeta?.totalPages : false

    function handleSelect(diagnosis_concept_id: string): void {
        setPendingBlockValues([diagnosis_concept_id].concat(pendingBlockValues))
    }

    function handleRemove(value: string): void {
        setPendingBlockValues(pendingBlockValues.filter((v) => v !== value))
    }

    return (
        <div style={{ padding: '20px', position: 'relative' }}>
            <input
                type='text'
                placeholder='Search Observations'
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                style={{ width: '100%', padding: '10px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px' }}
            />
            <div style={{ display: 'flex', marginBottom: '20px', width: '100dvw' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '60px' }}>
                <div
                    style={{
                        flex: 1,
                        marginRight: '10px',
                        border: '1px solid #ccc',
                        padding: '10px',
                        borderRadius: '5px',
                        minHeight: '350px',
                        overflow: 'hidden'
                    }}
                >
                    <strong>Search Results</strong>
                    <div
                        style={{
                            flex: 1,
                            minHeight: '350px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        {refResults.length === 0 && <div style={{ marginTop: '10px', color: '#aaa' }}>Search to browse observations</div>}
                        <Box width='100%' height='100%'>
                            <InfiniteScroll
                                dataLength={refResults.length}
                                next={() => {
                                    fetchMoreData()
                                }}
                                hasMore={hasMoreData}
                                loader={
                                    <div className='flex justify-center items-center py-4'>
                                        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary'></div>
                                    </div>
                                }
                                className='w-full overflow-y-scroll pr-3 mr-[-12px] space-y-3 max-h-[350px]'
                            >
                                {refResults.map((item, index) => (
                                    <div
                                        key={`${item.observation}-${index}`}
                                        onClick={() => handleSelect(item.observation)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginTop: '10px',
                                            width: '100%',
                                            borderBottom: '1px solid #ccc',
                                            padding: '10px',
                                            height: '100%'
                                        }}
                                    >
                                        <input
                                            type='checkbox'
                                            style={{ marginRight: '10px' }}
                                            onClick={() => handleSelect(item.observation)}
                                            disabled={pendingBlockValues.includes(item.observation)}
                                            checked={pendingBlockValues.includes(item.observation)}
                                            onChange={() => handleSelect(item.observation)}
                                        />
                                        <span
                                            style={{
                                                textAlign: 'left',
                                                textTransform: 'none',
                                                flex: 1,
                                                paddingBottom: '10px'
                                            }}
                                        >
                                            {item.observation}
                                        </span>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </Box>
                    </div>
                </div>
                <div style={{ flex: 1, marginLeft: '10px', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', minHeight: '150px' }}>
                    <strong>
                        Selected{' '}
                        <button
                            className='text-xs'
                            style={{
                                color: '#007bff',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                marginLeft: '5px',
                                background: 'none',
                                border: 'none',
                                padding: '0'
                            }}
                            onClick={() => setPendingBlockValues([])}
                        >
                            Remove all
                        </button>
                    </strong>
                    <div
                        style={{
                            marginTop: '10px',
                            paddingLeft: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            maxHeight: '350px',
                            overflow: 'scroll'
                        }}
                    >
                        {pendingBlockValues.map((value, index) => (
                            <div
                                key={`${value}-${index}`}
                                style={{
                                    padding: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    borderBottom: '1px solid #ccc',
                                    marginTop: index === 0 ? '0px' : '10px'
                                }}
                            >
                                <span style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => handleRemove(value)}>
                                    🗑️
                                </span>
                                <span>{refData.find((item) => item.observation === value)?.observation}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <button
                style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: isInitialBlockValues ? '#ccc' : '#004085',
                    color: '#fff',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '5px'
                }}
                disabled={isInitialBlockValues}
            >
                + Save Criteria
            </button>
        </div>
    )
}
